import type CurrencyCode from '@alltrails/types/CurrencyCode';

/**
 * Converts a major-unit amount to Stripe API minor units.
 *
 * Logic extracted from stripe.js bundle (minified). Module 8595:
 *   o = { bif:1, clp:1, ... } — zero decimal; bhd, jod, kwd, omr, tnd: 1e3 (three decimal); usdc: 1e6.
 * Default 100 (two decimal places).
 * Minor amount = major * multiplier → we use Math.round(major * multiplier).
 */
const STRIPE_JS_CURRENCY_MULTIPLIER: Partial<Record<CurrencyCode, number>> = {
  BHD: 1e3,
  BIF: 1,
  CLP: 1,
  DJF: 1,
  GNF: 1,
  JOD: 1e3,
  JPY: 1,
  KMF: 1,
  KRW: 1,
  KWD: 1e3,
  MGA: 1,
  OMR: 1e3,
  PYG: 1,
  RWF: 1,
  TND: 1e3,
  USDC: 1e6,
  VND: 1,
  VUV: 1,
  XAF: 1,
  XOF: 1,
  XPF: 1
};

const DEFAULT_MULTIPLIER = 100;

function toMinorUnits(amountInMajorUnit: number, currencyCode: CurrencyCode): number {
  const multiplier = STRIPE_JS_CURRENCY_MULTIPLIER[currencyCode] ?? DEFAULT_MULTIPLIER;
  return Math.round(amountInMajorUnit * multiplier);
}

export default toMinorUnits;
